import { useState } from 'react';

import Icon from '../../../components/AppIcon';

const SocialLogin = () => {
  const [loadingProvider, setLoadingProvider] = useState(null);

  const socialProviders = [
    {
      id: 'google',
      name: 'Google',
      icon: 'Chrome',
      bgColor: 'bg-white hover:bg-gray-50',
      textColor: 'text-gray-700',
      borderColor: 'border-gray-300'
    },
    {
      id: 'linkedin',
      name: 'LinkedIn',
      icon: 'Linkedin',
      bgColor: 'bg-[#0A66C2] hover:bg-[#004182]',
      textColor: 'text-white',
      borderColor: 'border-[#0A66C2]'
    }
  ];

  const handleSocialLogin = (providerId) => {
    setLoadingProvider(providerId);
    setTimeout(() => {
      setLoadingProvider(null);
      alert(`Social login with ${providerId} is not implemented in this demo`);
    }, 1500);
  };

  return (
    <div className="space-y-4">
      <div className="relative">
        <div className="absolute inset-0 flex items-center">
          <div className="w-full border-t border-border"></div>
        </div>
        <div className="relative flex justify-center text-sm">
          <span className="px-4 bg-card text-muted-foreground">Or continue with</span>
        </div>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {socialProviders?.map((provider) => (
          <button
            key={provider?.id}
            type="button"
            onClick={() => handleSocialLogin(provider?.id)}
            disabled={loadingProvider !== null}
            className={`flex items-center justify-center gap-3 px-4 py-3 rounded-lg border ${provider?.bgColor} ${provider?.textColor} ${provider?.borderColor} transition-smooth disabled:opacity-50 disabled:cursor-not-allowed`}
          >
            {loadingProvider === provider?.id ? (
              <div className="w-5 h-5 border-2 border-current border-t-transparent rounded-full animate-spin"></div>
            ) : (
              <Icon name={provider?.icon} size={20} />
            )}
            <span className="font-medium">{provider?.name}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default SocialLogin;